import React from "react";
import ErrorView from "../ErrorView/ErrorView";
import LoadingView from "../LoadingView/LoadingView";

function LoaderWrapper({ loading = false, error, children }) {
  return !loading ? !error ? <>{children}</> : <ErrorView /> : <LoadingView />;
}

export default LoaderWrapper;
